<article class="card">
  <div class="card__header">
    <div class="card__title-group">
      @if (title()) {
        <h3 class="card__title">{{ title() }}</h3>
      }
      @if (hasInfo()) {
        <button 
          type="button" 
          class="card__info-button" 
          (click)="infoClicked.emit()"
          aria-label="Information">
          <img 
            src="./assets/lib/icons/info_icon.svg" 
            alt="Information" 
            class="card__info-icon" />
        </button>
      }
    </div>
    @if (iconPath) {
      <button 
        type="button" 
        class="card__icon-button" 
        (click)="iconClicked.emit()"
        aria-label="Card action">
        <img 
          [src]="iconPath" 
          [alt]="icon()" 
          class="card__icon" />
      </button>
    }
  </div>
  @if (isAlert()) {
    <div class="card__alert">
      <img src="./assets/lib/icons/icon_Safety Alert.svg" alt="Safety Alert">
    </div>
  }
  @if (disclaimer()) {
    <p class="card__disclaimer">{{ disclaimer() }}</p>
  }
  @if (subtitle() && subtitle()!.length > 0) {
    <div class="card__subtitle-container">
      @for (line of subtitle(); track $index) {
        <p class="card__subtitle">{{ line }}</p>
      }
    </div>
  }
</article>
